<template>
  <v-app>
    <Navbar :user="user"></Navbar>
    <v-content class>
      <router-view />
    </v-content>
    <v-snackbar v-model="snackbars.showing" :timeout="snackbars.timeout" :color="snackbars.color">
      {{ snackbars.text }}
      <v-btn color="black" text @click="snackbars.showing = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
//import * as firebase from "firebase/app";
//import "firebase/auth";
//import "@firebase/firestore";
//import { db } from "./main";

export default {
  name: "App",
  components: {
    Navbar
  },
  computed: {
    snackbars() {
      return this.$store.getters.getSnackbars;
    }
  },
  created() {
    this.$store.dispatch("getUserData");
    this.$store.dispatch("GET_CLASSES");

    if (
      this.$store.getters.getList == null ||
      this.$store.getters.getList == undefined ||
      this.$store.getters.getList.length < 1
    ) {
      this.$store.dispatch("Persons");
    }
  },
  mounted() {},

  data: () => ({
    user: null
  })
};
</script>
<style>
.bg {
  background: linear-gradient(135deg, #172a74, #21a9af);
  background-color: #184e8e;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>
